module.exports = __webpack_public_path__ + "static/media/ic_indian_resident.d769bf27.svg";